module.exports = __webpack_public_path__ + "static/media/black-widow-lose.fb1deba4.png";